import { getI18nT } from "@fanfanlo";
import { Namespace, TFunction } from "i18next";
let _trans:TFunction<Namespace, undefined>
export async function initAndroidComponentsI18n(){
    _trans = await getI18nT("droid-android/android/components/content")
}
initAndroidComponentsI18n()
export function getTrans(){
    return _trans
}